import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ClientService } from '../../client.service';

import { ServiceTicketRoutingProvider } from '@store';
import { Installations, WaitingTimeResponse } from './bff-installations.model';

@Injectable()
export class BffInstallationsApi {
  constructor(private clientService: ClientService) {}

  /**
   * Returns list of all user installations.
   */
  listInstallations(
    params: { cursor?: string; companyNumber?: string } = {}
  ): Observable<Installations> {
    const endpoint = `vitoguide/installations/v2/all-gateways`;

    return this.clientService.get(endpoint, params);
  }

  /**
   * Returns current waiting time in seconds for a phone queue for the given serial number.
   * Additionally returns the queue name and amount of waiting calls.
   * @param boilerSerial
   */
  postWaitingTime(boilerSerial: string): Observable<WaitingTimeResponse> {
    const endpoint = `vitoguide/installations/v2/service/time`;

    return this.clientService.post(endpoint, { boilerSerial });
  }

  /**
   * Returns phone number which can be used to call TDs.
   * @param phoneNumber
   * @param boilerSerial
   */
  postPhone(
    boilerSerial: string,
    phoneNumber?: string,
    errorCodes?: string[],
    description?: string
  ): Observable<{ acdNumber: string }> {
    const params = { boilerSerial };

    if (phoneNumber) {
      params['phoneNumber'] = phoneNumber;
    }

    params['errorCodes'] = errorCodes;
    params['description'] = description;

    const endpoint = `vitoguide/installations/v2/service/phone`;

    return this.clientService.post(endpoint, params);
  }

  /**
   * Requests callback in service app for specific phone number.
   * @param boilerSerial
   * @param phoneNumber
   */
  postCallback(
    boilerSerial: string,
    phoneNumber: string,
    errorCode?: string[],
    description?: string
  ): Observable<{ id: string }> {
    const endpoint = `vitoguide/installations/v2/service/callback`;
    let errorCodes: string[];

    if (errorCode) {
      errorCodes = errorCode;
    }

    return this.clientService.post(endpoint, {
      phoneNumber,
      boilerSerial,
      errorCodes,
      description,
    });
  }

  /**
   * Return routing provider in service app.
   * @param serialNumber
   */
  getRoutingProvider(
    serialNumber: string
  ): Observable<{ routingProvider: ServiceTicketRoutingProvider }> {
    const endpoint = `vitoguide/installations/v2/routing`;

    return this.clientService.get(endpoint, {
      serialNumber,
    });
  }
}
